import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import { useEffect, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { ProductDetails } from "../components/product_details"
import { useCookies } from "react-cookie"
import { useNavigate, useParams } from "react-router-dom"
import { BarLoader } from "react-spinners"
import { PayPalButtons } from "@paypal/react-paypal-js";
import { IoMdCheckmarkCircleOutline } from "react-icons/io"

export default function ShippingPolicy({ route }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount } = useCart();
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [cookies, removeCookie] = useCookies();
    const navigate = useNavigate();
    const [payment, setPayment] = useState("cod");
    const [pageData, setPageData] = useState({});
    const {reference} = useParams();

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            <Navbar />
            <div className="max-w-6xl mx-auto px-4 py-6">
                <div className="flex">
                    <button onClick={() => navigate(-1)} className="py-2 px-5 border rounded-sm my-2">Return to Shop</button>
                </div>
                <div className="max-w-5xl mx-auto px-4 py-10">
                    <h1 className="text-3xl font-semibold mb-6">
                        Shipping Policy
                    </h1>

                    <p className="text-gray-700 mb-6">
                        This Shipping Policy outlines how orders are processed and delivered
                        by <strong>Intimates By Itee Ltd</strong>. By placing an order on our
                        website, you agree to the terms below.
                    </p>

                    <section className="space-y-6 text-[#232323]">
                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Order Processing
                        </h2>
                        <p>
                            All orders are processed within <strong>1–3 business days</strong>
                            (excluding weekends and public holidays) after receiving your
                            order confirmation email. Once your order has been shipped, you
                            will receive a notification with tracking information.
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Shipping Locations
                        </h2>
                        <p>
                            <strong>Intimates By Itee Ltd</strong> is based in the United Kingdom
                            and delivers orders worldwide. We work with trusted international
                            courier partners to ensure safe and timely delivery to our
                            customers across different countries.
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Shipping Rates & Delivery Time
                        </h2>
                        <p>
                            Shipping charges for your order will be calculated and displayed
                            at checkout. Delivery times may vary depending on your location,
                            shipping method selected, and customs clearance processes.
                        </p>
                        <p className="mt-2">
                            Estimated delivery times typically range from:
                        </p>
                        <ul className="list-disc list-inside mt-2">
                            <li>United Kingdom: 2–5 business days</li>
                            <li>Europe: 5–10 business days</li>
                            <li>International: 7–15 business days</li>
                        </ul>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Customs, Duties & Taxes
                        </h2>
                        <p>
                            International orders may be subject to customs duties, taxes, or
                            import fees depending on the destination country. These charges
                            are the responsibility of the customer and are not included in
                            the product or shipping cost.
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Order Tracking
                        </h2>
                        <p>
                            Once your order has been shipped, you will receive a tracking
                            number via email. Please allow up to 24 hours for tracking
                            information to become active.
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Lost or Delayed Shipments
                        </h2>
                        <p>
                            While we strive to deliver all orders on time, delays may occur
                            due to unforeseen circumstances such as customs processing or
                            courier issues. <strong>Intimates By Itee Ltd</strong> is not
                            responsible for delays caused by shipping carriers.
                        </p>
                        <p className="mt-2">
                            If you believe your order is lost, please contact us so we can
                            assist you in resolving the issue.
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Contact Us
                        </h2>
                        <p>
                            If you have any questions regarding our Shipping Policy, please
                            contact our customer support team. We are always happy to assist
                            you.
                        </p>
                        </div>
                    </section>
                </div>

            </div>
            <Footer />
        </div>
    )
}
